import React, { useState, useEffect, useRef } from 'react';

import { DraggableModal } from 'src/app/components';
import 'src/app/popup.scss';
import styles from 'src/app/pages/Administration/tabs/SettingTab/setting.module.scss';

import { useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { contentsActions } from 'src/app/redux/actions';
import { errorLocals } from 'src/locals';
import { settingService, logsService } from 'src/app/services';
import { statusHelper } from 'src/app/helpers';
import moment from 'moment';

import { SettingDataType } from 'src/types/services/setting-service.type';
import { SettingFormType } from './settingForm.config';
import { displaySuccessStatusMessage } from 'src/app/helpers/status.helper';
import { LogsData } from '../../Logs/logs.config';
import Logs from '../../Logs/Logs';

import { useTranslation } from 'react-i18next';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import DatePicker from 'antd/es/date-picker';

const { TextArea } = Input;

const SettingForm: React.FC<SettingFormType> = ({
  onClickOpen,
  setOnClickOpen,
  setEditModal,
  settingForm,
  setViewModal,
}) => {
  const { t } = useTranslation();

  const defaultSettingData = {
    id: '',
    name: '',
    createdById: '',
    description: '',
    roadToCurrentState: '',
    creationDate: undefined,
    geoDataSet: '',
    geoSituation: '',
    keyPersonSet: '',
    agentData: '',
    log: '',
    comment: '',
  };

  const dispatch = useDispatch();
  const fileInputRef = useRef<any>();
  const [form] = Form.useForm();
  const [settingId, setSettingId] = useState('');
  const { fieldsList } = useSelector((state: reduxRootTypes.RootStateType) => state.fieldsState);
  const [fieldsId, setFieldsId] = useState<any[]>([]);

  const [addSettingModal, setAddSettingModal] = useState<boolean>(false);
  const [id, setId] = useState<number | undefined>();
  const [logsData, setLogsData] = useState<LogsData[]>([]);
  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);

  const [settingDataInForm, setSettingDataInForm] = useState<SettingDataType>(settingForm || defaultSettingData);
  const { usersList } = useSelector((state: reduxRootTypes.RootStateType) => state.userListState);

  const onFormChange = (inputLabel: keyof SettingDataType, value: any) => {
    setSettingDataInForm({
      ...settingDataInForm,
      [inputLabel]: value,
    });
  };

  useEffect(() => {
    const getFormList = async () => {
      const settingListData = await settingService.lookupSetting({});

      let max = 0;
      settingListData.data.rows.forEach((each) => {
        const value = Number(each.id.split('-')[1]);
        if (value > max) {
          max = value;
        }
      });
      setId(max + 1);
    };
    getFormList();
  }, [settingForm]);

  useEffect(() => {
    if (setEditModal !== true) {
      form.setFieldsValue({
        settingId: settingId,
      });
    }
  }, [settingId]);

  useEffect(() => {
    let settingForFieldId = [];
    if (fieldsList) {
      settingForFieldId = fieldsList.filter((obj) => obj.fieldsType === 12 && obj.id === settingForm?.id);
      settingForFieldId = settingForFieldId.map((e) => e.id);
      setFieldsId(settingForFieldId);
    }
  }, [fieldsList]);

  const getLogsData = async () => {
    try {
      const logData = await logsService.lookupLogs({
        fieldIds: fieldsId.length > 0 ? fieldsId : undefined,
        blockSpinner: true,
      });

      const tempLog: LogsData[] = [];
      logData.data.rows.forEach((obj, index) => {
        const detail = obj.description;

        const match = detail.match(/has been\s+(\w+)/i);
        const actionWord = match?.[1]?.toLowerCase();

        const action =
          actionWord === 'created'
            ? 'CREATE'
            : actionWord === 'updated'
            ? 'UPDATE'
            : actionWord === 'deleted'
            ? 'DELETE'
            : 'Unknown';

        const username = usersList.find((e) => e.id === obj.createdById)?.userName || '-';

        tempLog.push({
          key: index,
          user: username,
          action,
          details: detail,
          timestamp: moment(obj.createdAt).format('HH:mm DD/MM/YYYY'),
        });
      });

      setLogsData(tempLog);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (fieldsId.length > 0) {
      getLogsData();
    }
  }, [fieldsId]);

  const handleOnFinishEdit = async (ruleData: SettingDataType) => {
    try {
      const formData = new FormData();

      const SettingUpdateData = await settingService.SettingEdit(
        {
          ...ruleData,
          id: settingForm.id, //  @ts-ignore
          createdById: settingForm.createdById,
        },
        formData,
      );
      setAddSettingModal(false);
      setSettingDataInForm(defaultSettingData);
      dispatch(contentsActions.settingEdited(SettingUpdateData.data));
      displaySuccessStatusMessage(t('success.edited'));
      setOnClickOpen(false);
    } catch (error: any) {
      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(error.response.data.message);
      }
    }
  };
  const handleOnFinishAdd = async (requestData: SettingDataType) => {
    try {
      const formData = new FormData();
      const settingAddData = await settingService.createSetting(
        {
          ...requestData,
          createdById: userState.id,
        },
        formData,
        {
          blockErrorHandler: true,
        },
      );
      setAddSettingModal(false);
      setSettingDataInForm(defaultSettingData);
      dispatch(contentsActions.settingAdded(settingAddData.data));
      dispatch(contentsActions.fieldListAdd({ id: settingAddData.data.id, fieldsType: 12 }));
      displaySuccessStatusMessage(t('success.added'));
      setOnClickOpen(false);
    } catch (error) {
      console.log(error);

      if (error !== errorLocals.errorHandledError) {
        statusHelper.displayErrorMessage(t('errors.unknownError'));
      }
    }
  };

  return (
    <>
      {onClickOpen && (
        <DraggableModal
          headerText={
            setEditModal
              ? t('administration.scenarioSettings.editSetting')
              : setViewModal
              ? t('administration.scenarioSettings.viewSetting')
              : t('administration.scenarioSettings.addSetting')
          }
          onClickClose={() => setOnClickOpen(false)}
          style={{ width: '800px', height: '600px' }}
        >
          <Form
            scrollToFirstError={{ behavior: 'smooth' }}
            initialValues={{
              ...settingDataInForm,
            }}
            onFinish={setEditModal ? handleOnFinishEdit : handleOnFinishAdd}
            form={form}
          >
            <div className="popup-main-container">
              <div className="popup-container">
                <div className="popup-content" style={{ padding: 0 }}>
                  <div className={styles.container} style={{ padding: 10, marginRight: 15 }}>
                    <div className="popup-row grid-col-2-fixed">
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.scenarioSettings.name')}</span>
                        <Form.Item
                          name="name"
                          initialValue={setEditModal ? settingForm?.name : undefined}
                          rules={[{ required: true, message: t('general.required') || '' }, { max: 95 }]}
                        >
                          <Input
                            type="text"
                            className={styles.standard_input}
                            value={settingDataInForm.name}
                            maxLength={95}
                            name="name"
                            disabled={setViewModal}
                          />
                        </Form.Item>
                      </div>

                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.scenarioSettings.geoDataSet')}</span>
                        <Form.Item
                          name="geoDataSet"
                          initialValue={setEditModal ? settingForm?.geoDataSet : undefined}
                          rules={[{ required: true, message: t('general.required') || '' }, { max: 95 }]}
                        >
                          <Input
                            className={styles.standard_input}
                            value={settingDataInForm.geoDataSet}
                            maxLength={96}
                            type="text"
                            disabled={setViewModal}
                            placeholder=""
                            onChange={(e) => onFormChange('geoDataSet', e as unknown as string)}
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('general.creationDate')}</span>
                        <Form.Item name="creationDate">
                          <DatePicker
                            showTime
                            format="YYYY-MM-DD HH:mm:ss"
                            style={{ marginTop: '5px', width: '100%' }}
                            value={settingDataInForm.creationDate ? moment(settingDataInForm.creationDate) : undefined}
                            disabled
                          />
                        </Form.Item>
                      </div>

                      <div className="popup-input-container">
                        <span className="popup-input-title">
                          {t('administration.scenarioSettings.roadToCurrentState')}
                        </span>
                        <Form.Item
                          name="roadToCurrentState"
                          rules={[{ required: true, message: t('general.required') || '' }, { max: 95 }]}
                          initialValue={setEditModal ? settingForm?.roadToCurrentState : undefined}
                        >
                          <Input
                            className={styles.standard_input}
                            value={settingDataInForm.roadToCurrentState}
                            maxLength={96}
                            disabled={setViewModal}
                            placeholder=""
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.scenarioSettings.keyPersonSet')}</span>
                        <Form.Item
                          name="keyPersonSet"
                          rules={[{ required: true, message: t('general.required') || '' }, { max: 95 }]}
                          initialValue={setEditModal ? settingForm?.keyPersonSet : undefined}
                        >
                          <Input
                            placeholder=""
                            className={styles.standard_input}
                            maxLength={96}
                            value={settingDataInForm.keyPersonSet}
                            disabled={setViewModal}
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.scenarioSettings.geoSituation')}</span>
                        <Form.Item
                          name="geoSituation"
                          rules={[{ required: true, message: t('general.required') || '' }, { max: 95 }]}
                          initialValue={setEditModal ? settingForm?.geoSituation : undefined}
                        >
                          <Input
                            placeholder=""
                            className={styles.standard_input}
                            maxLength={96}
                            value={settingDataInForm.geoSituation}
                            disabled={setViewModal}
                          />
                        </Form.Item>
                      </div>
                      <div className="popup-input-container">
                        <span className="popup-input-title">{t('administration.scenarioSettings.agentData')}</span>
                        <Form.Item
                          name="agentData"
                          rules={[{ required: true, message: t('general.required') || '' }, { max: 95 }]}
                          initialValue={setEditModal ? settingForm?.agentData : undefined}
                        >
                          <Input
                            placeholder=""
                            className={styles.standard_input}
                            maxLength={96}
                            value={settingDataInForm.agentData}
                            disabled={setViewModal}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.description')}</span>
                      <Form.Item
                        name="description"
                        rules={[{ required: false, message: t('general.required') || '' }, { max: 255 }]}
                        initialValue={setEditModal ? settingForm?.description : undefined}
                      >
                        <TextArea
                          rows={3}
                          placeholder=""
                          maxLength={256}
                          showCount
                          value={settingDataInForm.description}
                          disabled={setViewModal}
                        />
                      </Form.Item>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.comment')}</span>
                      <Form.Item
                        name="comment"
                        rules={[
                          { required: false, message: t('general.required') || '' },
                          { max: 1024, message: t('errors.max1024') || '' },
                        ]}
                        initialValue={setEditModal ? settingForm?.comment : undefined}
                      >
                        <TextArea
                          rows={3}
                          className={styles.standard_input}
                          autoSize={{ minRows: 3, maxRows: 3 }}
                          maxLength={10001}
                          value={settingDataInForm.comment}
                          disabled={setViewModal}
                        />
                      </Form.Item>
                    </div>
                    <div className="popup-input-container">
                      <span className="popup-input-title">{t('general.log')}</span>
                      <Form.Item name="log" initialValue={setEditModal ? settingForm?.log : undefined}>
                        <Logs logsData={logsData} />
                      </Form.Item>
                    </div>

                    {/* <div className="popup-input-container">
                      <span className="popup-input-title">Geo Situation</span>
                      <Form.Item name="geoSituation" rules={[{ required: true, message: t('general.required') || '' }]}>
                        <Select
                          getPopupContainer={(trigger) => trigger.parentElement}
                          disabled={setViewModal}
                          labelInValue
                          className={styles.select}
                        >
                          {allToAbbreviation.length > 0 &&
                            Object.values(
                              ontologies.filter((o) => o.ontologyType === OntologyEnum.Security_Status),
                            ).map((option, idx) => (
                              <Select.Option key={option.id} value={option.id}>
                                {option.abbreviation}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="popup-footer"
              style={{ marginRight: '7%', marginTop: '2%', display: setViewModal ? 'none' : 'relative' }}
            >
              <div>
                <button
                  className="next-button"
                  type="submit"
                  // disabled={checkRLSMUpdatePermission(
                  //   userState,
                  //   PermissionEnum.SettingCreate,
                  //   SettingDataInForm,
                  //   setEditModal,
                  // )}
                >
                  {t('general.save')}
                </button>
                <button className="modal-button" onClick={() => setOnClickOpen(false)} type="button">
                  {t('general.cancel')}
                </button>
              </div>
            </div>
          </Form>
        </DraggableModal>
      )}
    </>
  );
};

export default SettingForm;
